
const mind = {
  namespaced: true,
  state: {
    activeSidebar: '', // 当前显示的侧边栏
  },
  mutations: {
    // 设置当前显示的侧边栏
    setActiveSidebar (state, data) {
      state.activeSidebar = data
    }
  }
}

export default mind
